import React from 'react';

interface UserMessageProps {
  message: string;
}

export const UserMessage: React.FC<UserMessageProps> = ({ message }) => (
  <div className="flex justify-end w-full px-4">
    <div className="bg-navy text-white rounded-2xl rounded-tr-sm px-4 py-2.5 max-w-[75%] text-sm leading-relaxed">
      {message}
    </div>
  </div>
);
